import Markdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

import { ContextualEntityChatMention } from "src/unifiedCopilot/chat/ContextualEntityChatMention";
import {
  inlineStandaloneReferences,
  parseReferenceAttributes,
} from "src/unifiedCopilot/chat/contextualEntityReferenceContent";
import {
  CONTEXTUAL_ENTITY_REFERENCE_ELEMENT_TAG,
  remarkContextualEntityReference,
} from "src/unifiedCopilot/chat/remarkContextualEntityReference";
import { isReferenceContextualEntityType } from "src/unifiedCopilot/context/entityDefinitions";

type ContextualEntityReferenceElementProps =
  React.HTMLAttributes<HTMLElement> & {
    "data-reference"?: string;
  };

const ContextualEntityReferenceElement: React.FC<
  ContextualEntityReferenceElementProps
> = ({ "data-reference": raw, children }) => {
  const attrs = parseReferenceAttributes(raw ?? "");
  if (!attrs.id || !attrs.label) return <>{children}</>;

  const { label, ...rest } = attrs;
  const mention = <ContextualEntityChatMention attrs={rest} label={label} />;
  if (!isReferenceContextualEntityType(attrs.kind)) return mention;

  return (
    <span className="inline-block max-w-full p-0.5 align-middle">
      {mention}
    </span>
  );
};

const components = {
  [CONTEXTUAL_ENTITY_REFERENCE_ELEMENT_TAG]: ContextualEntityReferenceElement,
} as Components;

const remarkPlugins = [remarkGfm, remarkContextualEntityReference];

export const UnifiedCopilotMarkdownRenderer: React.FC<{
  content: string;
}> = ({ content }) => (
  <div className="tktl-markdown break-words font-inter-normal-13px text-gray-800">
    <Markdown components={components} remarkPlugins={remarkPlugins}>
      {inlineStandaloneReferences(content)}
    </Markdown>
  </div>
);
